import React, { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import Responsive from '@/components/Responsive';
import { getAdaptedBaseCardContent } from '@/modules/content/card/utils/getAdaptedBaseCardContent';
import { getStatus } from '@/modules/corporate/modules/quiz/utils';
import { QuizDetailsContentFragment } from '@/modules/corporate/modules/quiz/views/QuizDetails/graphql/fragments/generated/QuizDetailsContent';
import { QuizDetailsPerformanceFragment } from '@/modules/corporate/modules/quiz/views/QuizDetails/graphql/fragments/generated/QuizDetailsPerformance';

import PopupQuizCardDesktop from './index.desktop';
import PopupQuizCardMobile from './index.mobile';

interface Props {
  className?: string;
  quiz: QuizDetailsContentFragment;
  quizPerformance?: QuizDetailsPerformanceFragment;
  onClick?: () => void;
  overrideActionLabel?: string | null;
  headerAction?: React.ReactNode;
}

function PopupQuizCardContainer(props: Props) {
  const { className, quiz, quizPerformance, onClick, overrideActionLabel, headerAction } = props;
  const { t } = useTranslation();
  const content = useMemo(
    () => ({ ...getAdaptedBaseCardContent(t, quiz), label: t('Common:ResourceType.Quiz') }),
    [quiz, t],
  );

  const status = useMemo(
    () => getStatus({ quiz, performance: quizPerformance, t, useLatestAttempt: true }),
    [quiz, quizPerformance, t],
  );

  return (
    <Responsive>
      <Responsive.Default>
        <PopupQuizCardDesktop
          hideBookmark
          className={className}
          content={content}
          headerAction={headerAction}
          overrideActionLabel={overrideActionLabel}
          quiz={quiz}
          quizPerformance={quizPerformance}
          status={status}
          onClick={onClick}
        />
      </Responsive.Default>
      <Responsive.Mobile>
        <PopupQuizCardMobile
          className={className}
          content={content}
          headerAction={headerAction}
          overrideActionLabel={overrideActionLabel}
          quiz={quiz}
          quizPerformance={quizPerformance}
          status={status}
          onClick={onClick}
        />
      </Responsive.Mobile>
    </Responsive>
  );
}

export default PopupQuizCardContainer;
